import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Icon } from '@homeexchange/design';
import i18n from '../../i18n';
import Exchange from '../../models/Exchange';
import Home from '../../models/Home';
import Api from '../../api/Api';
import FakeApi from '../../api/FakeApi';
import Tour from '../../utils/Tour';

export default class HomeSwitcher extends React.PureComponent {
    static propTypes = {
        exchange: PropTypes.instanceOf(Exchange),
        switchable: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        isOnModification: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            homes: [],
            homeSelected: props.exchange.get('home') ? props.exchange.get('home').id : null,
            homesLoaded: false
        };
        this.homeRef = React.createRef();
        this.switcherRef = React.createRef();
        this.carouselRef = React.createRef();
        this.handleEdit = this.handleEdit.bind(this);
        this.handleChoose = this.handleChoose.bind(this);
    }

    componentDidMount() {
        this.fetchHomes(this.props.exchange);
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    componentDidUpdate() {
        this.loadImage();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            homeSelected: nextProps.exchange.get('home')
                ? nextProps.exchange.get('home').id
                : _.first(this.state.homes)
        });

        if (
            this.props.exchange &&
            this.props.exchange.id &&
            nextProps.exchange &&
            nextProps.exchange.id &&
            this.props.exchange.id != nextProps.exchange.id
        ) {
            this.fetchHomes(nextProps.exchange);
            this.setState({
                homesLoaded: false
            });
        }
    }

    fetchHomes(exchange) {
        Tour.shouldUseFakeApi('messaging_tour', 'Home.get').then((shouldUseFakeApi) => {
            if (shouldUseFakeApi) {
                FakeApi.MessagingTour.Home.get(
                    { user: exchange.get('host').id },
                    { fullCompletionDate: 'DESC' },
                    1000
                ).then((homes) => {
                    this.handleHomeCallback(homes);
                });
            } else {
                Api.Home.getGraphQL(exchange.get('host').id)
                    .then((homes) =>
                        _.sortBy(homes, (home) => Math.sin(moment(home.full_completion_date).format('X')))
                    )
                    .then((homes) => {
                        this.handleHomeCallback(homes);
                    });
            }
        });
    }

    handleHomeCallback(homes) {
        if (this._isUnmounted) {
            // component is unmounted, don't update it
            return;
        }
        // instanciate Homes
        homes = homes.map((home) => new Home(home));
        this.setState(
            {
                homes,
                homesLoaded: true
            },
            () => {
                document.dispatchEvent(new CustomEvent('home_switcher_ready'));
            }
        );
    }

    loadImage() {
        $(this.homeRef.current)
            .add(this.carouselRef.current)
            .find('.home-picture-content')
            .each((index, element) => {
                // remove "lazyloading" class (loader) on picture loaded
                if (element.getAttribute('data-picture')) {
                    const img = new Image();
                    img.onload = function () {
                        element.style.backgroundImage = `url(${this.src})`;
                        $(element).closest('.lazyloading').removeClass('lazyloading');
                    };
                    img.onerror = function () {
                        $(element).addClass('no-picture');
                        $(element).closest('.lazyloading').removeClass('lazyloading');
                    };
                    img.src = element.getAttribute('data-picture');
                } else {
                    $(element).addClass('no-picture');
                    $(element).closest('.lazyloading').removeClass('lazyloading');
                }
            });
    }

    getAvailableHomes() {
        return this.state.homes.filter(
            (home) =>
                home.get('status') == Home.STATUS_ONLINE &&
                home.get('completion_rate') >= Home.MINIMUM_FILLING_TO_CONTACT
        );
    }

    handleEdit(event) {
        event.preventDefault();
        this.setState({
            mode: 'edit'
        });
    }

    handleChoose(event) {
        event.preventDefault();
        const homeId = $(event.target).closest('[data-home]').attr('data-home');
        const home = this.state.homes.find((h) => h.id == homeId);
        if (!home) {
            throw new Error('Home does not exists for this user.');
        }
        this.props.onChange(home);
        this.setState({
            mode: 'view',
            homeSelected: home.id
        });
    }

    render() {
        if (this.state.homesLoaded === false) {
            return (
                <article className="home">
                    <div
                        className={classNames('home-picture', {
                            lazyloading: !this.state.homesLoaded
                        })}
                    ></div>
                </article>
            );
        } else if (this.state.mode === 'edit') {
            return this.renderEditMode();
        } else {
            return this.renderViewMode();
        }
    }

    renderViewMode() {
        const host = this.props.exchange.get('host');
        const home = this.state.homes.find((h) => h.id == this.state.homeSelected);
        // if the selected home does not exists, display error
        if (!home) {
            return (
                <article className="home" data-home={this.state.homeSelected} ref={this.homeRef}>
                    <span className="header"></span>
                    <span className="home-unavailable">
                        {i18n.t('exchange:home_unavailable', {
                            first_name: host.get('first_name')
                        })}
                    </span>
                    {this.renderEditButton()}
                </article>
            );
        }
        return (
            <article className="home" data-home={home.id} ref={this.homeRef}>
                <a
                    className="home-picture lazyloading"
                    href={i18n.t('home:home.view.url', { id: home.id })}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div className="home-picture-content" data-picture={home.picture(400, 225, false)} />
                </a>
                <a
                    className="header"
                    href={i18n.t('home:home.view.url', { id: home.id })}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className="title">{home.title()}</span>
                    <div>
                        <Icon name="Moon" />
                        <span>
                            {i18n.t('common:duration.night', {
                                count: this.props.exchange.getNightNb()
                            })}
                        </span>
                    </div>
                    <span className="location">{home.location()}</span>
                </a>
                {this.renderErrorIfUnavailable(home)}
                {this.renderEditButton()}
            </article>
        );
    }

    renderErrorIfUnavailable(home) {
        if (home.get('status') != Home.STATUS_ONLINE) {
            return (
                <span className="home-unavailable">
                    {i18n.t('exchange:home_unavailable', {
                        first_name: home.get('user').get('first_name')
                    })}
                </span>
            );
        }
        return null;
    }

    renderEditButton() {
        const host = this.props.exchange.get('host');
        const availableHomes = this.getAvailableHomes();
        const homeEditLabel = i18n.t('exchange:user_has_several_homes', {
            first_name: host.get('first_name'),
            count: availableHomes.length
        });
        if (this.props.switchable && availableHomes.length > 1) {
            return (
                <div>
                    {!this.props.isOnModification && (
                        <a href="#" onClick={this.handleEdit} className="home-editable">
                            <Icon name="Pencil" aria-hidden="true" />
                            <span className="sr-only">{homeEditLabel}</span>
                        </a>
                    )}
                    <a href="#" className="reciprocal-overlay" onClick={this.handleEdit}>
                        <p>
                            {homeEditLabel}
                            <br />
                            <em>{i18n.t('exchange:choose_other_home')}</em>
                        </p>
                    </a>
                </div>
            );
        }
        return null;
    }

    renderEditMode() {
        const availableHomes = this.getAvailableHomes();
        // retrieve home selected
        let homeSelected = availableHomes.find((home) => home.id == this.state.homeSelected);
        // if home selected is not in online homes list, select the first one
        if (!homeSelected) {
            homeSelected = _.first(availableHomes);
        }
        return (
            <div
                id="carousel-home-switcher"
                className="carousel home-switcher-carousel slide"
                data-ride="carousel"
                data-interval="false"
                ref={this.carouselRef}
            >
                <div className="carousel-inner" role="listbox">
                    {availableHomes.map((home) => (
                        <div
                            className={classNames('item', {
                                active: home.id == homeSelected.id
                            })}
                            key={home.id}
                        >
                            <article className="home home-editing" data-home={home.id} ref={this.homeRef}>
                                <div className="home-picture lazyloading">
                                    <div
                                        className="home-picture-content"
                                        data-picture={home.picture(400, 225, false)}
                                    />
                                </div>
                                <div className="header">
                                    <a
                                        className="title"
                                        href={i18n.t('home:home.view.url', {
                                            id: home.id
                                        })}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {home.title()}
                                    </a>
                                    <span className="location">{home.location()}</span>
                                    <a className="choose-home" href="#" onClick={this.handleChoose}>
                                        {i18n.t('exchange:choose_this_home')} <Icon name="Check" />
                                    </a>
                                </div>
                            </article>
                        </div>
                    ))}
                </div>
                <a
                    className="left carousel-control"
                    href="#carousel-home-switcher"
                    role="button"
                    data-slide="prev"
                >
                    <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                </a>
                <a
                    className="right carousel-control"
                    href="#carousel-home-switcher"
                    role="button"
                    data-slide="next"
                >
                    <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                </a>
            </div>
        );
    }
}
